import ChildField from "../child-field/child-field";

export default class ClearSearchOnModalClose {
    constructor(element, triggerElement, targetForm) {
        this.$element = $(element);
        this.$trigger = $(triggerElement);
        this.$targetForm = $(targetForm);
        this.query = JSON.parse(sessionStorage.getItem('hpBackToSearch')).query;
    }

    restoreValues() {
        //checkboxes
        if (typeof(this.query['attr_m_channel_i']) === 'undefined') {
            for(var i=1;i<5;i++){
                $('.quick-search__form').find(`[name="attr_m_channel_i"][value="${i}"]`).prop('checked',false);}
        }
        else if(typeof(this.query['attr_m_channel_i']) !== 'undefined') { //if defined, make everything false first, them make true for only those required
            for(var i=1;i<5;i++){
                this.$targetForm.find(`[name="attr_m_channel_i"][value="${i}"]`).prop('checked',false);}
            this.query['attr_m_channel_i'].forEach((v) => {
                this.$targetForm.find(`[name="attr_m_channel_i"][value="${v}"]`).prop('checked',true);
            });
        }
        //maker
        if(typeof(this.query['maker']) === 'undefined') {
            this.$targetForm.find('[id="maker"]').val(null);
        }
        else if(typeof(this.query['maker']) !== 'undefined') {
            this.$targetForm.find('[id="maker"]').val(this.query['maker'][0]);
            this.$targetForm.find('[id="makeModelId"]').val(this.query['maker'][0]);
        }
        //model
       if(typeof(this.query['model']) === 'undefined') {
           this.$targetForm.find('[id="model"]').val(null);
       }
       else if(this.query['model'] !== undefined){
            this.$targetForm.find('[name="attr_m_trim"]').val(this.query['model'][0]);
            this.$element.on('optionsTreeUpdate:finish', () => {
                this.$targetForm.find('[id="model"]').val(this.query['model'][0]);
           });
       }
        //other attributes
       this.query['attr_price_max'] === undefined ? this.$targetForm.find('[id="attr_price_max"]').val(null) :
            this.$targetForm .find('[id="attr_price_max"]').val(this.query['attr_price_max'][0]);

       this.query['attr_m_km_max'] === undefined ? this.$targetForm.find('[id="attr_m_km_max"]').val(null) :
            this.$targetForm .find('[id="attr_m_km_max"]').val(this.query['attr_m_km_max'][0]);

       this.query['attr_m_fuel'] === undefined ? this.$targetForm.find('[id="attr_m_fuel"]').val(null) :
            this.$targetForm .find('[id="attr_m_fuel"]').val(this.query['attr_m_fuel'][0]);

       this.query['attr_m_year_min'] === undefined ? this.$targetForm.find('[id="attr_m_year_min"]').val(null) :
            this.$targetForm .find('[id="attr_m_year_min"]').val(this.query['attr_m_year_min'][0]);

      //  this.query['location_name'] === undefined ?this.$targetForm.find('input').attr('id', zipcode).val(null) :
        //      this.$targetForm .find('input').attr('id', zipcode).val(this.query['location_name'][0]);

       this.query['area_id'] === undefined ? this.$targetForm.find('[id="zipcode"]').val(null) :
            this.$targetForm .find('[id="zipcode"]').val(this.query['location_name'][0]);
        $('#maker').trigger('change.childField'); //update the options of model, when maker is changed
    }

    setListeners() {
        this.$trigger
            .off('click.clearonclose')
            .on('click.clearonclose', this.restoreValues.bind(this));
    }

    init() {
        this.setListeners();
    }
}
